module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "e22a":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():undefined}(this,(function(){"use strict";function e(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function t(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function n(n){for(var r=1;r<arguments.length;r++){var o=null!=arguments[r]?arguments[r]:{};r%2?t(Object(o),!0).forEach((function(t){e(n,t,o[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(n,Object.getOwnPropertyDescriptors(o)):t(Object(o)).forEach((function(e){Object.defineProperty(n,e,Object.getOwnPropertyDescriptor(o,e))}))}return n}var r={height:"h",width:"w",aspectRatio:"ar",quality:"q",crop:"c",cropMode:"cm",x:"x",y:"y",focus:"fo",format:"f",radius:"r",background:"bg",border:"bo",rotation:"rt",rotate:"rt",blur:"bl",named:"n",overlayImage:"oi",overlayImageAspectRatio:"oiar",overlayImageBackground:"oibg",overlayImageBorder:"oib",overlayImageDPR:"oidpr",overlayImageQuality:"oiq",overlayImageCropping:"oic",overlayImageTrim:"oit",overlayX:"ox",overlayY:"oy",overlayFocus:"ofo",overlayHeight:"oh",overlayWidth:"ow",overlayText:"ot",overlayTextFontSize:"ots",overlayTextFontFamily:"otf",overlayTextColor:"otc",overlayTextTransparency:"oa",overlayAlpha:"oa",overlayTextTypography:"ott",overlayBackground:"obg",overlayTextEncoded:"ote",overlayTextWidth:"otw",overlayTextBackground:"otbg",overlayTextPadding:"otp",overlayTextInnerAlignment:"otia",overlayRadius:"or",progressive:"pr",lossless:"lo",trim:"t",metadata:"md",colorProfile:"cp",defaultImage:"di",dpr:"dpr",effectSharpen:"e-sharpen",effectUSM:"e-usm",effectContrast:"e-contrast",effectGray:"e-grayscale",original:"orig"},o=["path","query"],i=function(){return"path"},a=function(e){return"query"===e.transformationPosition},s=function(e){return-1!=o.indexOf(e.transformationPosition)},u=function(e){return e&&(r[e]||r[e.toLowerCase()])||""},p=function(){return":"},f=function(){return","},l=function(){return"-"},c=function(e){if(!e.path&&!e.src)return"";var t,n,r;if(e.path?(r=new URL(e.urlEndpoint).pathname,t=new URL(y([e.urlEndpoint.replace(r,""),e.path]))):(t=new URL(e.src),n=!0),!t)return"";for(var o in e.sdkVersion&&""!=e.sdkVersion.trim()&&t.searchParams.append("ik-sdk-version",e.sdkVersion.trim()),e.queryParameters)t.searchParams.append(o,e.queryParameters[o]);var i=function(e){if(!Array.isArray(e))return"";for(var t=[],n=0,r=e.length;n<r;n++){var o=[];for(var i in e[n]){var a=u(i);if(a||(a=i),"-"===e[n][i])o.push(a);else{var s=e[n][i];"oi"===a&&(s=(s=d(s)).replace(/\//g,"@@")),o.push([a,s].join(l()))}}t.push(o.join(f()))}return t.join(p())}(e.transformation);return i&&i.length&&(a(e)||n?t.searchParams.append("tr",i):t.pathname=y(["tr"+p()+i,t.pathname])),t.pathname=y([r,t.pathname]),t.href};function d(e){return"string"==typeof e&&"/"==e[0]&&(e=e.slice(1)),e}function y(e,t){var n=t||"/",r=new RegExp(n+"{1,}","g");return e.join(n).replace(r,n)}var I={MANDATORY_INITIALIZATION_MISSING:{message:"Missing urlEndpoint during SDK initialization",help:""},INVALID_TRANSFORMATION_POSITION:{message:"Invalid transformationPosition parameter",help:""},PRIVATE_KEY_CLIENT_SIDE:{message:"privateKey should not be passed on the client side",help:""},MISSING_UPLOAD_DATA:{message:"Missing data for upload",help:""},MISSING_UPLOAD_FILE_PARAMETER:{message:"Missing file parameter for upload",help:""},MISSING_UPLOAD_FILENAME_PARAMETER:{message:"Missing fileName parameter for upload",help:""},MISSING_AUTHENTICATION_ENDPOINT:{message:"Missing authentication endpoint for upload",help:""},AUTH_ENDPOINT_TIMEOUT:{message:"The authenticationEndpoint you provided timed out in 60 seconds",help:""},AUTH_ENDPOINT_NETWORK_ERROR:{message:"Request to authenticationEndpoint failed due to network error",help:""},UPLOAD_ENDPOINT_NETWORK_ERROR:{message:"Request to ImageKit upload endpoint failed due to network error",help:""}};function h(e,t,n){"function"==typeof n&&(e?n(t,null):n(null,t))}var T=function(e,t){var n=new XMLHttpRequest;n.timeout=6e4,n.open("GET",e.authenticationEndpoint),n.ontimeout=function(e){"function"==typeof t&&h(!0,I.AUTH_ENDPOINT_TIMEOUT,t)},n.onerror=function(){h(!0,I.AUTH_ENDPOINT_NETWORK_ERROR,t)},n.onload=function(){if(200===n.status)try{var e=JSON.parse(n.responseText),r={signature:e.signature,expire:e.expire,token:e.token};return void t(null,r)}catch(e){if("function"!=typeof t)return;t(e)}else try{var o=JSON.parse(n.responseText);if("function"!=typeof t)return;t(o)}catch(e){if("function"!=typeof t)return;t(e)}},n.send()},g=function(e,t){var n=new XMLHttpRequest;n.open("POST","https://upload.imagekit.io/api/v1/files/upload"),n.onerror=function(){h(!0,I.UPLOAD_ENDPOINT_NETWORK_ERROR,t)},n.onload=function(){if(200===n.status){if("function"!=typeof t)return;var e=JSON.parse(n.responseText);t(null,e)}else if(200!==n.status){if("function"!=typeof t)return;t(JSON.parse(n.responseText))}},n.send(e)},O=function(e,t,n){if(e)if(e.file)if(e.fileName)if(t.authenticationEndpoint){var r=new FormData;for(var o in e)r.append(o,e[o]);r.append("publicKey",t.publicKey),function(e,t,n){T(t,(function(t,r){if(t){if("function"!=typeof n)return;n(t,null)}else e.append("signature",r.signature||""),e.append("expire",r.expire||0),e.append("token",r.token),g(e,(function(e,t){if(e){if("function"!=typeof n)return;n(e,null)}else n(null,t)}))}))}(r,t,n)}else h(!0,I.MISSING_AUTHENTICATION_ENDPOINT,n);else h(!0,I.MISSING_UPLOAD_FILENAME_PARAMETER,n);else h(!0,I.MISSING_UPLOAD_FILE_PARAMETER,n);else h(!0,I.INVALID_UPLOAD_OPTIONS,n)},m="1.3.4";return function(e){if(e=e||{},this.options={sdkVersion:"javascript-".concat(m),publicKey:"",urlEndpoint:"",transformationPosition:i()},this.options=n(n({},this.options),e),!this.options.urlEndpoint)throw I.MANDATORY_INITIALIZATION_MISSING;if(function(e){return void 0!==e.privateKey}(this.options))throw I.PRIVATE_KEY_CLIENT_SIDE;if(!s(this.options))throw I.INVALID_TRANSFORMATION_POSITION;this.url=function(e){return function(e,t){var r=n(n({},t),e);return function(e){return!!e.urlEndpoint}(r)?c(r):""}(e,this.options)},this.upload=function(e,t,r){var o=n(n({},this.options),r);return O(e,o,t)}}}));


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ImageKit", function() { return /* reexport */ ImageKit; });
__webpack_require__.d(__webpack_exports__, "IKContext", function() { return /* reexport */ IKContext; });
__webpack_require__.d(__webpack_exports__, "IKImage", function() { return /* reexport */ IKImage; });
__webpack_require__.d(__webpack_exports__, "IKUpload", function() { return /* reexport */ IKUpload; });
__webpack_require__.d(__webpack_exports__, "IKCore", function() { return /* reexport */ imagekit_min["ImageKit"]; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/IKContext.vue?vue&type=script&lang=js&
/* harmony default export */ var IKContextvue_type_script_lang_js_ = ({
  name: "ik-context",
  inheritAttrs: false,
  provide: function provide() {
    var contextConfigurations = {};
    Object.assign(contextConfigurations, this.$attrs);
    return {
      contextConfigurations: contextConfigurations
    };
  },
  render: function render() {
    return this.$scopedSlots.default();
  }
});
// CONCATENATED MODULE: ./src/components/IKContext.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_IKContextvue_type_script_lang_js_ = (IKContextvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/IKContext.vue
var render, staticRenderFns




/* normalize component */

var component = normalizeComponent(
  components_IKContextvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IKContext = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"3ae7a02c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/IKImage.vue?vue&type=template&id=068b8f1e&
var IKImagevue_type_template_id_068b8f1e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"ik-image",attrs:{"src":_vm.srcImage}})}
var IKImagevue_type_template_id_068b8f1e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/IKImage.vue?vue&type=template&id=068b8f1e&

// EXTERNAL MODULE: ./node_modules/imagekit-javascript/dist/imagekit.min.js
var imagekit_min = __webpack_require__("e22a");
var imagekit_min_default = /*#__PURE__*/__webpack_require__.n(imagekit_min);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/IKImage.vue?vue&type=script&lang=js&
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//


/* harmony default export */ var IKImagevue_type_script_lang_js_ = ({
  name: "ik-image",
  inject: {
    contextConfigurations: {
      default: {}
    }
  },
  data: function data() {
    return {
      intersected: false,
      observer: null,
      originalSrcLoaded: false
    };
  },
  props: {
    urlEndpoint: {
      type: String,
      default: "",
      required: false
    },
    publicKey: {
      type: String,
      default: "",
      required: false
    },
    authenticationEndpoint: {
      type: String,
      default: "",
      required: false
    },
    path: {
      type: String,
      default: "",
      required: false
    },
    src: {
      type: String,
      default: "",
      required: false
    },
    transformation: {
      type: Array,
      required: false
    },
    transformationPosition: {
      type: String,
      required: false
    },
    queryParameters: {
      type: Object,
      required: false
    },
    lqip: {
      type: Object,
      default: null,
      required: false
    },
    loading: {
      type: String,
      default: ""
    }
  },
  methods: {
    getMergedOptions: function getMergedOptions() {
      return _objectSpread(_objectSpread({}, this.defaultOptions), this.contextConfigurations);
    },
    getClient: function getClient() {
      return new imagekit_min_default.a({
        sdkVersion: "vuejs-".concat(VERSION),
        urlEndpoint: this.urlEndpoint ? this.urlEndpoint : this.contextConfigurations.urlEndpoint
      });
    },
    triggerOriginalImageLoad: function triggerOriginalImageLoad() {
      var _this = this;

      var img = new Image();

      img.onload = function () {
        _this.originalSrcLoaded = true;
      };

      img.src = this.imageAttrs.src;
    },
    getEffectiveConnection: function getEffectiveConnection() {
      try {
        return navigator.connection.effectiveType;
      } catch (ex) {
        return "4g";
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // use client specific APIs in client-side hooks only
    if (window && 'IntersectionObserver' in window && this.loading === "lazy") {
      var connectionType = this.getEffectiveConnection(); // Values based on native lazy loading in Chrome - https://web.dev/native-lazy-loading/#improved-data-savings-and-distance-from-viewport-thresholds

      var rootMargin = "1250px";
      if (connectionType !== "4g") rootMargin = "2500px";
      this.observer = new IntersectionObserver(function (entries) {
        var image = entries[0];

        if (image && image.isIntersecting) {
          _this2.intersected = true;
          if (_this2.lqip) _this2.triggerOriginalImageLoad();

          _this2.observer.disconnect();
        }
      }, {
        rootMargin: "".concat(rootMargin, " 0px ").concat(rootMargin, " 0px")
      });
      this.observer.observe(this.$el);
    } else {
      // Load image right away
      if (this.lqip) this.triggerOriginalImageLoad();
    }
  },
  destroyed: function destroyed() {
    this.observer.disconnect();
  },
  computed: {
    srcImage: function srcImage() {
      /*
        No lazy loading no lqip
          src=originalImage
         No lazy loading lqip
          src=lqip
          src=originalImage (when loaded)
         lazy loading and no lqip
          src=''
          onIntersect:
            src=originalImage
         lazy loading and lqip
          src=lqip
          onInterserct:
            src=originalImage (when loaded)
      */
      if (this.loading !== "lazy" && this.lqip === null) {
        return this.imageAttrs.src;
      } else if (this.loading !== "lazy" && this.lqip && this.lqip.active) {
        if (this.originalSrcLoaded) {
          return this.imageAttrs.src;
        } else {
          return this.imageAttrs.lqipSrc;
        }
      } else if (this.loading === "lazy" && this.lqip === null) {
        if (this.intersected) {
          return this.imageAttrs.src;
        } else {
          return "";
        }
      } else if (this.loading === "lazy" && this.lqip && this.lqip.active) {
        if (this.intersected && this.originalSrcLoaded) {
          return this.imageAttrs.src;
        } else {
          return this.imageAttrs.lqipSrc;
        }
      }

      return this.imageAttrs.src;
    },
    imageAttrs: function imageAttrs() {
      var mergedOptions = this.getMergedOptions();
      var IkClient = this.IkClient || this.getClient();
      var options = {
        urlEndpoint: this.urlEndpoint ? this.urlEndpoint : mergedOptions.urlEndpoint,
        src: this.src,
        path: this.path,
        transformation: this.transformation,
        transformationPosition: this.transformationPosition,
        queryParameters: this.queryParameters
      };
      var result = {};
      result.src = IkClient.url(options);

      if (this.lqip && this.lqip.active) {
        var quality = parseInt(this.lqip.quality || this.lqip.threshold, 10) || 20;
        var blur = parseInt(this.lqip.blur || this.lqip.blur, 10) || 6;
        var transformation = options.transformation || [];
        transformation.push({
          quality: quality,
          blur: blur
        });
        result.lqipSrc = IkClient.url(_objectSpread(_objectSpread({}, options), {}, {
          transformation: transformation
        }));
      }

      return result;
    }
  }
});
// CONCATENATED MODULE: ./src/components/IKImage.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_IKImagevue_type_script_lang_js_ = (IKImagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/IKImage.vue





/* normalize component */

var IKImage_component = normalizeComponent(
  components_IKImagevue_type_script_lang_js_,
  IKImagevue_type_template_id_068b8f1e_render,
  IKImagevue_type_template_id_068b8f1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IKImage = (IKImage_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"3ae7a02c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/IKUpload.vue?vue&type=template&id=cefbf3fe&
var IKUploadvue_type_template_id_cefbf3fe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"imageFile",attrs:{"type":"file"},on:{"change":_vm.upload}})}
var IKUploadvue_type_template_id_cefbf3fe_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/IKUpload.vue?vue&type=template&id=cefbf3fe&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/IKUpload.vue?vue&type=script&lang=js&
function IKUploadvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function IKUploadvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { IKUploadvue_type_script_lang_js_ownKeys(Object(source), true).forEach(function (key) { IKUploadvue_type_script_lang_js_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { IKUploadvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function IKUploadvue_type_script_lang_js_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//


/* harmony default export */ var IKUploadvue_type_script_lang_js_ = ({
  name: "ik-upload",
  inject: {
    contextConfigurations: {
      default: {}
    }
  },
  props: {
    urlEndpoint: {
      type: String,
      default: "",
      required: false
    },
    publicKey: {
      type: String,
      default: "",
      required: false
    },
    authenticationEndpoint: {
      type: String,
      default: "",
      required: false
    },
    fileName: {
      type: String,
      default: "",
      required: false
    },
    useUniqueFileName: {
      type: Boolean,
      default: true,
      required: false
    },
    tags: {
      type: Array,
      required: false
    },
    folder: {
      type: String,
      default: "/",
      required: false
    },
    isPrivateFile: {
      type: Boolean,
      default: false,
      required: false
    },
    customCoordinates: {
      type: String,
      default: "",
      required: false
    },
    responseFields: {
      type: Array,
      required: false
    },
    onError: {
      type: Function,
      required: false
    },
    onSuccess: {
      type: Function,
      required: false
    }
  },
  data: function data() {
    return {
      file: {}
    };
  },
  methods: {
    getMergedOptions: function getMergedOptions() {
      return IKUploadvue_type_script_lang_js_objectSpread(IKUploadvue_type_script_lang_js_objectSpread({}, this.defaultOptions), this.contextConfigurations);
    },
    getClient: function getClient() {
      return new imagekit_min_default.a({
        sdkVersion: "vuejs-".concat(VERSION),
        urlEndpoint: this.urlEndpoint ? this.urlEndpoint : this.contextConfigurations.urlEndpoint,
        publicKey: this.urlEndpoint || this.contextConfigurations.urlEndpoint,
        authenticationEndpoint: this.authenticationEndpoint || this.contextConfigurations.authenticationEndpoint
      });
    },
    upload: function upload() {
      var _this = this;

      var file = this.$refs.imageFile.files[0];
      var fileSystemFileName = file.name;
      var mergedOptions = this.getMergedOptions();
      var IkClient = this.IkClient || this.getClient();
      var publicKey = this.publicKey || mergedOptions.publicKey;
      var authenticationEndpoint = this.authenticationEndpoint || mergedOptions.authenticationEndpoint;

      if (!publicKey || publicKey.trim() === "") {
        if (typeof this.onError === "function") {
          this.onError({
            message: "Missing publicKey"
          });
        }

        return;
      }

      if (!authenticationEndpoint || authenticationEndpoint.trim() === "") {
        if (typeof this.onError === "function") {
          this.onError({
            message: "Missing authenticationEndpoint"
          });
        }

        return;
      }

      IkClient.upload({
        file: file,
        fileName: this.fileName || fileSystemFileName,
        useUniqueFileName: this.useUniqueFileName,
        tags: this.tags,
        folder: this.folder,
        isPrivateFile: this.isPrivateFile,
        customCoordinates: this.customCoordinates,
        responseFields: this.responseFields
      }, function (err, result) {
        if (err && typeof _this.onError === "function") {
          _this.onError(err);
        } else if (!err && typeof _this.onSuccess === "function") {
          _this.onSuccess(result);
        }
      }, {
        publicKey: publicKey,
        authenticationEndpoint: authenticationEndpoint
      });
      return;
    }
  }
});
// CONCATENATED MODULE: ./src/components/IKUpload.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_IKUploadvue_type_script_lang_js_ = (IKUploadvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/IKUpload.vue





/* normalize component */

var IKUpload_component = normalizeComponent(
  components_IKUploadvue_type_script_lang_js_,
  IKUploadvue_type_template_id_cefbf3fe_render,
  IKUploadvue_type_template_id_cefbf3fe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IKUpload = (IKUpload_component.exports);
// CONCATENATED MODULE: ./src/plugin.js
function plugin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function plugin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { plugin_ownKeys(Object(source), true).forEach(function (key) { plugin_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { plugin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function plugin_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var VERSION = "1.0.8";
var componentMapping = {
  "ik-context": IKContext,
  "ik-image": IKImage,
  "ik-upload": IKUpload
};
function plugin_install(Vue, options) {
  if (Vue.IkInstalled) {
    throw new Error("Imagekit plugin already installed");
  }

  options.defaultOptions = {
    sdkVersion: "vuejs-".concat(VERSION),
    publicKey: options.publicKey,
    urlEndpoint: options.urlEndpoint,
    authenticationEndpoint: options.authenticationEndpoint
  };
  options.IkClient = new imagekit_min_default.a(options.defaultOptions);
  Vue.IkInstalled = true;
  initComponents(Vue, options);
}

function initComponents(Vue, options) {
  var _loop = function _loop() {
    var componentName = options.components[i];
    var component = componentMapping[componentName];

    if (component) {
      Vue.component(componentName, plugin_objectSpread(plugin_objectSpread({}, component), {}, {
        data: function data() {
          return plugin_objectSpread(plugin_objectSpread({}, component.data ? component.data() : {}), {}, {
            IkClient: options.IkClient,
            defaultOptions: options.defaultOptions
          });
        }
      }));
    }
  };

  for (var i = 0; i < options.components.length; i++) {
    _loop();
  }
}
// CONCATENATED MODULE: ./src/index.js





var ImageKit = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!options.urlEndpoint || options.urlEndpoint.trim() === "") {
      throw new Error("urlEndpoint is required to initilize ImageKit");
    }

    if (!options.components || options.components.length === 0) {
      options.components = ["ik-image", "ik-context", "ik-upload"];
    }

    plugin_install(Vue, options);
  }
};

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (ImageKit);



/***/ })

/******/ });
//# sourceMappingURL=imagekitio-vue.common.js.map